import React from 'react';
import '../resources/css/order-cart.css';
import { Button, ButtonProps } from '@material-ui/core';
import { WebsocketClient } from '../websocket/module';
import Store from '../redux/store';
import { Theme, makeStyles, ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
// Message Modal
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from "../messenger/module";
import ShoppingCart from '../modules/shopping-cart';
// import i18n from '../i18n';
import _ from 'lodash';
import i18n from '../i18n';
import { getCacheField } from '../tools/get-cache-field';
import { FixedCartData } from '../pages/order-cart';
import { Cart2 } from '../modules/cart2/type';
import ServerShoppingCart from '../modules/server-shopping-cart';
import { StateManager } from '../redux/stateManager';
import RateReviewIcon from '@material-ui/icons/RateReview';
import CloseIcon from '@material-ui/icons/Close';

// 加入或移出购物车
enum UPGRADE {
    REMOVE_DISH = -1,
    ADD_DISH = 1,
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        backgroundColor: '#FF8873',
        borderColor: '#FF8873',
        '&:hover': {
            backgroundColor: '#FF8873',
            borderColor: '#935348',
            boxShadow: 'none',
        },
    }
}));

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#935348'
        }
    },
});
function StyledButton(props: ButtonProps) {
    const classes = useStyles();
    return (
        <Button {...props} classes={classes} />
    );
}

// 购物车详情列表组件
class OrderCartList extends React.Component<OrderRecordProps, OrderRecordState>{

    public messengerModule: MessengerModule;
    constructor(props: OrderRecordProps) {
        super(props);
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
        this.state = {
            checkedDish: false,
            condimentModel: false,
            // 调味品备注
            condimentsInfo: '',

            // 气泡标签提示
            setToolTip: Store.getState().markNumber ? false : true,
            markNum: Store.getState().markNumber,
            roundArr: [],
            // 选择删除的菜品
            selectedDishes: [],
        }
        // this.isExitDeviceStatus = this.isExitDeviceStatus.bind(this);
        this.updateLocalState = this.updateLocalState.bind(this);
    };

    public tpiTimer: any = null
    public COSTOMERKEYS: string[] = []

    // 货币符号
    public currency_name: string = '€';
    // *********************
    // Life Cycle
    // *********************
    public UNSAFE_componentWillMount() {
        const findRes = this.getSettingInfoValue('show-item-name1-or-item-name2')
        if (findRes) this.isShowName1 = findRes.value.showItemName1
        this.currency_name = StateManager.getFromCache('currency_name') || '€';

    }

    public componentDidMount() {
        if ((_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}`))) {
            this.COSTOMERKEYS = Object.keys(ShoppingCart.metaData[ShoppingCart.globalRound])
        }

        this.props.roundArr.forEach((v, i) => {
            this.state.roundArr.push(i + 1)
        })

        // $ 基于check组件的勾选问题，需要通过监听来取消勾选
        WebsocketClient.addListener('CANCEL_SELECT', () => {
            this.setState({ checkedDish: false })
        })

        // $ 记录用户第一次进入时，做法偏好气泡提示
        this.handleTooltipClose()

    }
    public componentWillUnmount() {
        this.tpiTimer && clearTimeout(this.tpiTimer)
        this.setState = (state, callback) => { return; };
    }

    // *********************
    // Function
    // *********************


    public isShowName1 = true;
    public getSettingInfoValue(str: string) {
        const SETTING = getCacheField('settingInfo');
        return _.find(SETTING, ['name', str]);
    }

    /**
     * 勾选的菜品
     */
    public selectedDish = (id: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const { selectedDishes } = this.props;
        if (event.target.checked) {
            selectedDishes.push(id);
        } else {
            _.remove(selectedDishes, (element: any) => {
                return element === id
            })
        }
        this.setState({ checkedDish: event.target.checked })
        this.props.updateLocalState({ selectedDishes })
    }

    /**
     * 更新调味品显示
     */
    public upDataCondimentMes(item: any) {
        return item.condiments?.map((val: Cart2.Condiment, index: number) => {
            // condimentsInfo.push(val.item_name1)
            return (
                <div key={index} className='condimentInfo'
                    onClick={(e) => {
                        e.stopPropagation()
                        item.condiments.splice(index, 1)
                        ServerShoppingCart.updateServerCart({
                            dish: item as any,
                            mathSymbol: 1,
                            action: { type: 1, state: 1, nonQuantity: true },
                            isAddedToCart: true,
                        })
                        this.props.updateLocalState({
                            condimentModel: false,
                            condimentsInfo: this.state.condimentsInfo.toString()
                        })
                    }}
                >
                    <p>{val.name.replace(/(_)/g, " ")}</p>
                    <CloseIcon style={{ fontSize: 16 }}></CloseIcon>
                </div>
            )
        })
        // return dish.map((val: Cart2.Condiment, index: number) => {
        //     // condimentsInfo.push(val.item_name1)
        //     return (
        //         <div key={index} className='condimentInfo' 
        //             onClick={() => {
        //                 dish.splice(index,1)
        //                 console.log('val',val,index);
        //                 // this.props.getOriginId(val)
        //                 // this.props.GETState(val.originId)
        //             }} 
        //         >
        //             <p>{val.name.replace(/(_)/g, " ")}</p>
        //             <CloseIcon style={{ fontSize: 16 }}></CloseIcon>
        //         </div>
        //     )
        // })
    }
    /**
      * 所有订单详情的合并
      */
    public mergeCartDetail() {
        let roundListDetail: any[] = [];
        this.COSTOMERKEYS.forEach((customerKey: string, index: number) => {
            let roundListDetailArr: any[] = [];

            if (_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}.${customerKey}`)) {
                Object.values(ShoppingCart.metaData[ShoppingCart.globalRound]).forEach((v: any) => {
                    roundListDetailArr = roundListDetailArr.concat(v);
                });
                roundListDetail = roundListDetailArr
            }
        });
        return roundListDetail
    }
    /**
     * 菜品数量增减
     */
    public changeMenuQuantity = async (itemDish: OrderRecordProps['item'], num: UPGRADE, notSelf?: boolean) => {
        // itemDish.dishesLock = true;
        // // 非自助点餐模式才触发菜品锁
        // if (!ShoppingCart.GLOBAL_SELF_ORDER_RULE) {
        //     this.addDishLock(itemDish)
        // }
        // $ 判断点餐顾客是否相同
        // if (itemDish.userName !== this.props.customer) {
        //     this.messengerModule.say({
        //         message: '菜品无法更改',
        //         level: 'Warning'
        //     })
        //     return;
        // }
        //
        ServerShoppingCart.updateServerCart({
            dish: itemDish as any,
            mathSymbol: num === 1 ? 0 : 1,
            action: { type: 0, state: 1, notSelf }
        });


        // /**
        //  * ShoppingCart 修改购物车中的菜品的数量。若操作数量不小于零且菜品不存在，则会创建菜品。
        //  * @param round 目标轮次
        //  * @param customer 目标顾客
        //  * @param dish 目标菜品
        //  * @param num 操作数量（正数为添加、负数为减少）
        //  */
        // const customer = getCacheField('orderTab.customer');

        // try {
        //     const result = ShoppingCart.updateDishCountInCart(
        //         ShoppingCart.globalRound,
        //         customer,
        //         num,
        //         itemDish._origin,
        //     )
        //     itemDish._origin.quantity = itemDish.count + itemDish.excessCount
        //     this.onRoundSelect(this.props.roles);
        //     // 发送当前加入的菜品
        //     // $ 非自主点餐模式下才触发
        //     if (!ShoppingCart.GLOBAL_SELF_ORDER_RULE) {
        //         num === 1 ?
        //             WebsocketClient.emitOrderClients({
        //                 event: 'ADD_DISH_COUNT',
        //                 customer,
        //                 wid: itemDish.originId,
        //                 dishes: itemDish._origin,
        //                 reportCount: result
        //             }) :
        //             WebsocketClient.emitOrderClients({
        //                 event: 'REMOVE_DISH_COUNT',
        //                 customer,
        //                 wid: itemDish.originId,
        //                 dishes: itemDish._origin,
        //                 reportCount: result
        //             })
        //     }
        //     // $ 菜品报告
        //     const dishReport = ShoppingCart.getDishAnalysis(itemDish._origin);
        //     if (num === 1) {
        //         WebsocketClient.emitOrderClients({
        //             event: 'DISH_REPORT',
        //             customer: this.props.customer,
        //             dishes: itemDish._origin,
        //             dishReport,
        //             cartData: ShoppingCart.metaData
        //         })
        //     }

        //     // // 发送购物车数据
        //     WebsocketClient.emitOrderClients({
        //         event: 'CREATE_DISH',
        //         customer: this.props.customer,
        //         dish: ShoppingCart.metaData
        //     })
        //     // 缓存购物车
        //     Store.dispatch({
        //         type: 'SET_CACHING',
        //         path: 'shoppingCart',
        //         value: ShoppingCart.metaData
        //     })

        //     // 在自助点餐更新自己的数量，非自助点餐同时更新其他设备
        //     if (ShoppingCart.GLOBAL_SELF_ORDER_RULE) {
        //         // 往自己设备发送更新
        //         WebsocketClient.emit('UPDATE_DISH_COUNT_SELF', {
        //             event: 'UPDATE_DISH_COUNT',
        //             customer: this.props.customer,
        //             turnInfo: getCacheField('turnInfo'),
        //             globalRound: ShoppingCart.globalRound
        //         })
        //     } else {
        //         // 往自己设备发送更新
        //         WebsocketClient.emit('UPDATE_DISH_COUNT_SELF', {
        //             event: 'UPDATE_DISH_COUNT_SELF',
        //             customer: this.props.customer,
        //             turnInfo: getCacheField('turnInfo')
        //         })
        //         // 往其他设备发送更新
        //         WebsocketClient.emitOrderClients({
        //             event: 'UPDATE_DISH_COUNT',
        //             customer: this.props.customer,
        //             turnInfo: getCacheField('turnInfo')
        //         })

        //     }

        //     // 非自助点餐模式才触发菜品锁
        //     if (!ShoppingCart.GLOBAL_SELF_ORDER_RULE) {
        //         // itemDish.dishesLock = false
        //         setTimeout(() => {
        //             // itemDish.dishesLock = false
        //             itemDish._origin.dishesLock = false;
        //             this.removeDishLock(itemDish)
        //         }, 300)
        //     }
        // } catch (error) {
        //     console.log('error:', error);

        //     // i18n.t('order_cart_page_text_round_max_order_count')
        //     this.messengerModule.say({
        //         message: error as string,
        //         level: 'Warning'
        //     })
        //     // 非自助点餐模式才触发菜品锁
        //     if (!ShoppingCart.GLOBAL_SELF_ORDER_RULE) {
        //         itemDish.dishesLock = false
        //         itemDish._origin.dishesLock = false;
        //         this.removeDishLock(itemDish)
        //         setTimeout(() => {
        //             itemDish.dishesLock = false
        //         }, 300)
        //     }
        // }
    }

    // $ 自主点餐模式开启下
    // 区分 每个顾客合并的购物车 和 顾客本身的购物车
    public onRoundSelect(eachRoundIndex: string) {
        // const { customer } = this.props;
        // let roundListDetail = [];
        // let totalPrice = 0;
        // let allRoundInfo = this.mergeCartDetail();
        // switch (eachRoundIndex) {
        //     case 'All':
        //         // 默认显示所有数据
        //         roundListDetail = allRoundInfo;
        //         break;

        //     case 'self':
        //         // 当前轮次数据
        //         roundListDetail = ShoppingCart.metaData[ShoppingCart.globalRound][customer] ?
        //             ShoppingCart.metaData[ShoppingCart.globalRound][customer] : [];
        //         break;
        //     default:
        //         // 当前轮次数据
        //         roundListDetail = ShoppingCart.metaData[ShoppingCart.globalRound][customer] ?
        //             ShoppingCart.metaData[ShoppingCart.globalRound][customer] : [];
        //         break;
        // }

        // // 计算出每轮的合计总量
        // for (let item of allRoundInfo) {
        //     totalPrice = totalPrice + parseFloat(item.totalPrice) + parseFloat(item.excessTotalPrice) + parseFloat(item.condimentsTotalPrice);
        // }
        //
        let roundListDetail = ServerShoppingCart.getCurrentCustomerCart({ all: eachRoundIndex === 'All' });

        this.props.updateLocalState({
            cartData: roundListDetail?.dishes,
            totalPrice: roundListDetail?.totalPrice
        })
    }
    // 做法偏好气泡提示
    public handleTooltipClose = () => {
        let conutMarkNum = this.state.markNum + 1;
        setTimeout(() => {
            this.setState({ setToolTip: false })
            Store.dispatch({
                type: 'SET',
                path: 'markNumber',
                value: conutMarkNum,
            })
        }, 3000)
    }

    /**
     * 整理套餐组内的菜品
     * - 获取totalNum大于0的
     */
    renderSetMenuDetail() {
        const setMealGroups = this.props.item.setMealGroups;
        let setMealDishes = _.flatMap(setMealGroups?.map((groupItem) => {
            return groupItem.items.filter((dishItem) => (dishItem.totalNum > 0))
        }))
        return setMealDishes;
    }

    /**
     * update local state by object
     * @param val
     */
    public updateLocalState(val: any) {
        this.setState(val, () => {
            this.onRoundSelect(this.props.roles)
        });
    }

    // *********************
    // View
    // *********************
    public render() {
        const { item, customer, showRemark } = this.props;
        const setMealDishes = this.renderSetMenuDetail()
        return (
            <div className='cartList_contain'>
                {/* Condiments Model */}
                {/* {
                    this.state.condimentModel &&
                    <Condiments
                        turnRound={turnRound}
                        customers={customer}
                        roundArr={roundArr}
                        customerArr={customerArr}
                        dish={item}
                        updateLocalState={this.updateLocalState}
                    />
                } */}
                <div className='cartListDetail_main'
                    onClick={
                        // 点击修改套餐
                        () => {
                            if (item.dishType === 1 && item.userName === customer) {
                                // 显示套餐菜品弹窗
                                this.props.showDishItemVisible();
                            }
                        }
                    }>
                    <div className='cartListDetail'>
                        {/* list Info */}
                        <div className='cartListDetail-infoLeft'>
                            {/* Checkbox */}
                            {/* {
                                (() => {
                                    if (autonomous.status) {
                                        return roles === 'self' &&
                                            <StyledCheckbox
                                                checked={this.state.checkedDish}
                                                onChange={this.selectedDish(item.id)}
                                                style={{ padding: 4 }} />
                                    } else {
                                        return <StyledCheckbox
                                            checked={this.state.checkedDish}
                                            onChange={this.selectedDish(item.id)}
                                            style={{ padding: 4 }} />
                                    }
                                })()
                            } */}
                        </div>

                        <div className='cartListDetail-infoRight'>
                            {/* list title */}
                            {
                                // index ?
                                <div className='leftText dishNameInfo' onClick={
                                    () => {
                                        // const second = Store.getState().roundTime
                                        // // $ 倒计时即将到下一轮, 轮次将自动推进, 会将未提交的菜品移至下一轮
                                        // // 设置倒计时最后5秒区间不能操作，为防止用户操作菜品导致轮次信息不一致
                                        // if (second > 5 || second < 0) {
                                        //     if (item.userName === customer) {
                                        //         this.props.showCondimentModel();
                                        //         this.setState({ condimentModel: true });
                                        //         if (!ShoppingCart.GLOBAL_SELF_ORDER_RULE) {
                                        //             // item.dishesLock = true;
                                        //             // item._origin.dishesLock = true;
                                        //             // this.addDishLock(item);
                                        //         }
                                        //     }
                                        // } else {
                                        //     this.messengerModule.say({
                                        //         level: 'Warning',
                                        //         message: `${i18n.t('order_cart_page_text_disable_edit_second', { s: second.toFixed(0) })}`,
                                        //     })
                                        // }
                                    }
                                }>
                                    <div className='itemName'>
                                        {this.isShowName1 ? item.name : item.name2}
                                    </div>
                                    <div >{`${item.originPrice.toFixed(2)} ${this.currency_name}`}</div>
                                    {
                                        item.userName !== this.props.customer && <div className='cloneDish' onClick={
                                            (e: any) => {
                                                // item.dishesLock = true

                                                // const isDish = Store.getState().isBusinessTime && item._origin.not_joining_global_limit !== 1
                                                // const CLONEDISH = _.cloneDeep(item);
                                                // CLONEDISH.userName = customer;
                                                // if (!isDish) {
                                                //     this.changeMenuQuantity(CLONEDISH, UPGRADE.ADD_DISH, item.originId)
                                                // } else {
                                                //     this.messengerModule.say({
                                                //         message: `${i18n.t('menu_page_text_dish_time_disable')}`,
                                                //         level: 'Warning'
                                                //     })
                                                // }
                                                e.stopPropagation()
                                                // 在别人点的菜上加入自己购物车一份
                                                this.changeMenuQuantity(item, UPGRADE.ADD_DISH, true);
                                            }}><p>+ 1</p></div>
                                    }
                                </div>
                                // :
                                // <CustomizedTooltips
                                //     placement="bottom-start"
                                //     open={this.state.setToolTip}
                                //     title={`${i18n.t('order_cart_page_text_select_preferences')}`}
                                // >
                                //     <div className='leftText dishNameInfo' onClick={
                                //         () => {
                                //             const second = Store.getState().roundTime
                                //             // $ 倒计时即将到下一轮, 轮次将自动推进, 会将未提交的菜品移至下一轮
                                //             // 设置倒计时最后5秒区间不能操作，为防止用户操作菜品导致轮次信息不一致
                                //             if (second > 5 || second < 0) {
                                //                 if (item.userName === customer) {
                                //                     this.props.showCondimentModel();
                                //                     this.setState({ condimentModel: true })
                                //                     ShoppingCart.condimentModel = true;
                                //                     if (!ShoppingCart.GLOBAL_SELF_ORDER_RULE) {
                                //                         // item.dishesLock = true;
                                //                         // item._origin.dishesLock = true;
                                //                         // this.addDishLock(item);
                                //                     }
                                //                 }
                                //             } else {
                                //                 this.messengerModule.say({
                                //                     level: 'Warning',
                                //                     message: `${i18n.t('order_cart_page_text_disable_edit_second', { s: second.toFixed(0) })}`,
                                //                 })
                                //             }
                                //         }
                                //     }>
                                //         <div className='itemName' style={{ flex: 1 }}>
                                //             {this.isShowName1 ? item.name : item.name2}
                                //         </div>
                                //         {
                                //             item.userName !== this.props.customer && <div className='cloneDish' onClick={
                                //                 () => {
                                //                     // // item.dishesLock = true
                                //                     // const isDish = Store.getState().isBusinessTime && item._origin.not_joining_global_limit !== 1
                                //                     // const CLONEDISH = _.cloneDeep(item);
                                //                     // CLONEDISH.userName = customer;
                                //                     // if (!isDish) {
                                //                     //     this.changeMenuQuantity(CLONEDISH, UPGRADE.ADD_DISH, item.originId)
                                //                     // } else {
                                //                     //     this.messengerModule.say({
                                //                     //         message: `${i18n.t('menu_page_text_dish_time_disable')}`,
                                //                     //         level: 'Warning'
                                //                     //     })
                                //                     // }
                                //                     // 在别人点的菜上加入自己购物车一份
                                //                     this.changeMenuQuantity(item, UPGRADE.ADD_DISH, true);
                                //                 }}><p>+ 1</p></div>
                                //         }
                                //     </div>
                                // </CustomizedTooltips>
                            }
                            {/* pic */}
                            <div className='countDish' style={{ margin: '5px 0' }}>
                                <div className='basisTextSize' onClick={
                                    (e) => {
                                        e.stopPropagation();
                                        if (!showRemark) return;
                                        const second = Store.getState().roundTime
                                        // $ 倒计时即将到下一轮, 轮次将自动推进, 会将未提交的菜品移至下一轮
                                        // 设置倒计时最后5秒区间不能操作，为防止用户操作菜品导致轮次信息不一致
                                        if (second > 5 || second < 0) {
                                            if (item.userName === customer) {
                                                this.props.showCondimentModel();
                                                this.setState({ condimentModel: true });
                                                if (!ShoppingCart.GLOBAL_SELF_ORDER_RULE) {
                                                    // item.dishesLock = true;
                                                    // item._origin.dishesLock = true;
                                                    // this.addDishLock(item);
                                                }
                                            }
                                        } else {
                                            this.messengerModule.say({
                                                level: 'Warning',
                                                message: `${i18n.t('order_cart_page_text_disable_edit_second', { s: second.toFixed(0) })}`,
                                            })
                                        }
                                    }
                                }>
                                    {
                                        showRemark && 
                                        <div style={{ width: '25px', height: '25px', borderRadius: '50%', backgroundColor: '#01CCCC', lineHeight: '28px', justifyContent: 'inherit' }}>
                                            <RateReviewIcon style={{ color: '#fff', fontSize: 16, marginTop: 5, marginLeft: 5 }} />
                                        </div>
                                    }
                                </div>
                                <div className='countBtn'>
                                    <ThemeProvider theme={theme}>
                                        {
                                            item.userName === this.props.customer &&
                                            <StyledButton

                                                className='count' onClick={(e) => {
                                                    e.stopPropagation()
                                                    this.changeMenuQuantity(item, UPGRADE.REMOVE_DISH);
                                                }}><div style={{ color: '#fff' }}> — </div></StyledButton>
                                        }

                                    </ThemeProvider>
                                    <div className='quantity'>{`${item.totalNum}`}</div>
                                    <ThemeProvider theme={theme}>
                                        {
                                            item.userName === this.props.customer &&
                                            <StyledButton

                                                className='count' onClick={(e) => {
                                                    e.stopPropagation()
                                                    // todo 分析 isDish
                                                    /**
                                                     * isBusinessTime 是否处于点餐时间段
                                                     * true 不处于点餐时间段
                                                     * false 处于点餐时间段
                                                     */
                                                    const isDish = Store.getState().isBusinessTime && item.r3Enable;
                                                    if (!isDish) {
                                                        this.changeMenuQuantity(item, UPGRADE.ADD_DISH);
                                                    } else {
                                                        this.messengerModule.say({
                                                            message: `${i18n.t('menu_page_text_dish_time_disable')}`,
                                                            level: 'Warning'
                                                        })
                                                    }
                                                }}><div style={{ color: '#fff' }}> ＋ </div></StyledButton>
                                        }
                                    </ThemeProvider>
                                </div>
                            </div>
                            {/* remarks  调味品显示*/}
                            <div className='leftText remarks basisTextSize' style={{ marginTop: '8px' }} onClick={(e) => { e.stopPropagation() }}>
                                {
                                    item.remark && <div className='condimentInfo'>
                                        <p>{item.remark}</p>
                                    </div>
                                }
                                {/* {this.upDataCondimentMes(item.condiments)} */}
                                {this.upDataCondimentMes(item)}
                            </div>
                            {/* Ext.超额 */}
                            <div className='leftText basisTextSize' style={{ color: '#00CCCC' }}>{item.excessPriceAndCondimentsPriceForView}</div>
                            {/* 套餐详情 */}
                            <div className='countDish'>
                                {item.dishType === 1 && (
                                    <div style={{ width: '100%' }}>
                                        <div className='set-meal-dishes-box1'>Scegli il prodotto</div>
                                        <div className='set-meal-dishes-box'>
                                            {(setMealDishes || []).map((item, index) => {
                                                return (
                                                    <div className='set-meal-dish-item' key={index}>
                                                        <span className='dot'></span>
                                                        <div className='setmenu-dish-name'>{this.isShowName1 ? item.name : item.name2}</div>
                                                        {item?.extraPrice > 0 ?
                                                            <span className='setmenu-extra-price-text'>
                                                                {`+`}{item.extraPrice.toFixed(2)}{this.currency_name}
                                                            </span>
                                                            : null}
                                                        {item.totalNum > 1 ?
                                                            <span className='setmenu-extra-price-text'>
                                                                {`×${item.totalNum}`}
                                                            </span>
                                                            : null}
                                                    </div >
                                                )
                                            })}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        )
    }
}
export default withSnackbar(OrderCartList);

// *********************
// Types
// *********************

type OrderRecordProps = {
    item: FixedCartData;
    index: number
    customer: string
    turnRound: null | string
    updateLocalState: (val: any) => void
    propUdateLocalState: (val: any) => void
    roles: string
    customerArr: string[]
    roundArr: string[]
    autonomous: {
        status: boolean
    }
    // 选择删除的菜品
    selectedDishes: Array<string>;
    // 显示调味品弹窗
    showCondimentModel: () => void;
    // 显示套餐弹窗
    showDishItemVisible: () => void;
    // 审核状态
    approvalStatus: 'REVIEW' | 'APPROVED' | 'NO' | 'REJECTED';
    // 展示备注
    showRemark: boolean;
} & WithSnackbarProps
type OrderRecordState = {
    checkedDish: boolean
    condimentModel: boolean
    condimentsInfo: string
    setToolTip: boolean
    markNum: number
    roundArr: number[]
    // 选择删除的菜品
    selectedDishes: Array<string>
}